module.exports = __webpack_public_path__ + "assets/img/Logitech-G-4-Social-Static-Ad-w540.19f9aadc.png";